'use strict';

// ital für Darsteller, Dauer, Regie

const renderEvents = (data, page = 1, actorList = 'Darsteller', length = 'Dauer', director = 'Regie') => {
    const timerStart = Date.now();
    const fragment = document.createDocumentFragment();
    // need to pass current page as parameter 
    page--;
    const maxItems = 10;

    let start = maxItems * page;
    let end = start + maxItems;



    // slice the array in portions of 20 items per page
    let paginatedItems = data.slice(start, end);
    // console.log(paginatedItems);

    paginatedItems.map((ele, i) => {

        const listItem = document.createElement('li');
        // listItem.style.borderTop = '1px solid black';
        listItem.style.padding = '2rem 0';
        // listItem.style.marginTop = '3rem';

        const infoContainer = document.createElement('div');
        infoContainer.style.marginBottom = '3rem';

        listItem.appendChild(infoContainer);

        const eventTitle = document.createElement('h2');
        eventTitle.textContent = ele.title;
        infoContainer.appendChild(eventTitle);

        const eventSubtitle = document.createElement('p');
        eventSubtitle.className = "strong-paragraph";
        eventSubtitle.textContent = ele.subtitle;
        infoContainer.appendChild(eventSubtitle);

        const eventBody = document.createElement('p');
        eventBody.textContent = ele.bodycopy;
        infoContainer.appendChild(eventBody);

        const movieList = document.createElement('ul');
        listItem.appendChild(movieList);

        ele.movies.map((ele, i) => {
            const listItem = document.createElement('li');
            listItem.className = "list-item";

            const imgWrapper = document.createElement('div');
            imgWrapper.className = "image-wrapper";
            listItem.appendChild(imgWrapper);

            if (ele.image) {
                const image = document.createElement('img');
                image.setAttribute('src', `${ele.image}`);
                // image.setAttribute('alt', `${ele.title}`);
                image.setAttribute('onerror', `this.onerror=null;this.src='';`);
              
                image.className = "item-image";
                imgWrapper.appendChild(image);
            }

            // infoContainer

            const infoContainer = document.createElement('div');
            infoContainer.className = "info-container";
            listItem.appendChild(infoContainer);

            // header

            const header = document.createElement('header');
            header.className = 'item-header';
            infoContainer.appendChild(header);

            // screeningDate

            const screeningDate = document.createElement('span');
            screeningDate.textContent = `${ele.screeningDate}, ${ele.screeningTime} Uhr`;
            header.appendChild(screeningDate);

            // name

            const itemTitle = document.createElement('h3');
            itemTitle.textContent = ele.title.toUpperCase();
            itemTitle.style.marginBottom = "0px";
            header.appendChild(itemTitle);

            // country and year

            const countryAndYear = document.createElement('span');
            countryAndYear.textContent = `${ele.country} ${ele.releaseYear}, `;
            header.appendChild(countryAndYear);


            const runtime = document.createElement('span');
            runtime.textContent = `${length}: ${ele.runtime} min, `;
            header.appendChild(runtime);

            // director and version

            const directorAndVersion = document.createElement('span');
            directorAndVersion.textContent = `${director}: ${ele.director} - ${ele.version}`;
            header.appendChild(directorAndVersion);

            // actorsContainer
            const actorsContainer = document.createElement('div');
            actorsContainer.className = 'actors-container';
            infoContainer.appendChild(actorsContainer);
            // actors

            const actors = document.createElement('span');
            const strong = document.createElement('strong');
            strong.textContent = `${actorList}: `
            actors.textContent = ele.actors;
            actorsContainer.appendChild(strong);
            actorsContainer.appendChild(actors);

            // Strong Copy Text

            if (ele.subtitle) {
                ele.subtitle.map(p => {
                    const subtitle = document.createElement('p');
                    subtitle.className = "strong-paragraph";
                    subtitle.textContent = p;
                    infoContainer.appendChild(subtitle);
                })
            }

            // Copy Text

            if (ele.bodycopy) {
                ele.bodycopy.map(p => {
                    const bodyCopy = document.createElement('p');
                    bodyCopy.className = "paragraph";
                    bodyCopy.textContent = p;
                    infoContainer.appendChild(bodyCopy);
                })
            }
            movieList.appendChild(listItem);
        })
        fragment.appendChild(listItem);
    })

    const duration = Date.now() - timerStart;
    // console.log(`duration: ${duration}`);

    return fragment;
}

export { renderEvents };